module.exports = __webpack_public_path__ + "static/media/Sean Shields Headshot_1672886325654.f374eaf4.jpeg";